import styled from '@emotion/styled';

/**
 * PhotoGridPage — Page 3 of the Kuutio print report.
 *
 * Black background, title at top, 3-column photo grid.
 * All values from IDML Spread_u8f3.xml via idml-to-css.mjs.
 *
 * Elements:
 *   u8fb: Black background (FillColor Black, full page)
 *   u9fb: Title text at left:32.6pt top:40.4pt (Rational Book 16pt/18pt, Paper color)
 *   u8827: Photo 1 at left:0pt top:81.5pt (280.6 x 391.9pt) — IMG_4205.jpeg
 *   u8836: Photo 2 at left:269.3pt top:81.5pt (280.6 x 391.9pt) — IMG_4212.jpeg
 *   u8828: Photo 3 at left:561.3pt top:81.5pt (280.6 x 391.9pt) — IMG_4225.jpeg
 */
export default function PhotoGridPage({
  instanceNumber = '3',
  topic = 'Kansainvälisten opiskelijoiden työllistyminen Suomeen',
}) {
  return (
    <Page className="page photo-grid-page">
      <Title>Tunnelmia #3. Kuutiosta Kaapelitehtaalta 18.-19.3.2026</Title>

      {/* u8827 left:0pt → IMG_4205, u8836 left:269.3pt → IMG_4225, u8828 left:561.3pt → IMG_4212 */}
      <Photo style={{ left: '0pt', top: '81.5pt' }}>
        <img src="/assets/report/IMG_4205.jpeg" alt="Workshop photo 1" />
      </Photo>
      <Photo style={{ left: '269.3pt', top: '81.5pt' }}>
        <img src="/assets/report/IMG_4225.jpeg" alt="Workshop photo 2" />
      </Photo>
      <Photo style={{ left: '561.3pt', top: '81.5pt' }}>
        <img src="/assets/report/IMG_4212.jpeg" alt="Workshop photo 3" />
      </Photo>

      <PageFooter>
        <FooterLeft><strong>Kuutio #{instanceNumber}:</strong> {topic}</FooterLeft>
        <FooterRight>3</FooterRight>
      </PageFooter>
    </Page>
  );
}

const Page = styled.div`
  width: 297mm;
  min-height: 210mm;
  background: #000;
  color: #fff;
  position: relative;
  font-family: 'Rational', sans-serif;
  box-sizing: border-box;
  overflow: hidden;

  @media print {
    break-after: page;
  }
`;

/* Title: Rational Text Book, 16pt, 18pt leading, white */
const Title = styled.h2`
  position: absolute;
  left: 32.6pt;
  top: 40.4pt;
  width: 568.3pt;
  font-size: 16pt;
  font-weight: 400;
  font-style: normal;
  line-height: 18pt;
  margin: 0;
  color: #fff;
`;

/* Photo frames: 280.6pt x 391.9pt each */
const Photo = styled.div`
  position: absolute;
  width: 280.6pt;
  height: 391.9pt;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const PageFooter = styled.div`
  position: absolute;
  bottom: 14pt;
  left: 42.5pt;
  right: 28.3pt;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 0.5pt solid rgba(255, 255, 255, 0.3);
  padding-top: 6pt;
`;

const FooterLeft = styled.span`
  font-size: 8pt;
  font-style: italic;
  font-weight: 400;
`;

const FooterRight = styled.span`
  font-size: 10pt;
  font-weight: 400;
`;
